<template>
  <b-container class="main-container">
    <!-- <b-modal id="approve-modal" title="Update Status" @ok="saveStatus">
      <p>Press 'OK' to mark this request with the selected status.</p>
      <p>You may also leave a note with this status change, which will be visible to the faculty member who made this
        buyout request.</p>

      <b-form-group label="Status" label-class="control-label workload-course-label"
        :class="{ 'invalid-group': $v.form.statusId.$error }">
        <b-form-select :options="statuses" v-model="form.statusId" text-field="name" value-field="id"
          :class="{ 'form-control': true, 'is-invalid': $v.form.statusId.$error }"></b-form-select>
      </b-form-group>

    </b-modal> -->

    <b-modal id="edit-modal" title="Edit Course Equivalent Request" v-model="openEditModal"
      @ok.prevent="attemptEditSubmit = true">
      <course-equivalent-form v-model="attemptEditSubmit" :terms="terms" :statuses="statuses" :item="item" v-if="item"
        v-on:complete="save"></course-equivalent-form>
    </b-modal>

    <h3 v-if="item">Course Equivalent
      <b-button v-if="isCourseEquivalentsManager" v-b-modal.edit-modal variant="primary"
        class="ml-2 pull-right">Edit</b-button>
    </h3>

    <h4 v-if="item">{{ item.term }} - {{ item.fullName }}</h4>

    <b-row v-if="item">
      <b-col>
        <widget heading="Details">
          <b-row>
            <b-col>
              <dl>
                <dt>Number of Classes</dt>
                <dd>{{ item.numberOfCourses }}</dd>
                <dt>Current Status</dt>
                <dd>{{ item.status }}</dd>
                <dt>Faculty</dt>
                <dd>{{ item.fullName }}</dd>
                <dt>Date</dt>
                <dd>{{ item.createdDate | formatDateTime }}</dd>
              </dl>
            </b-col>
            <b-col>
              <dl>
                <dt>Reason</dt>
                <dd>{{ item.reason }}</dd>
              </dl>
            </b-col>
          </b-row>
        </widget>

        <widget heading="Supporting Documents">
          <course-equivalent-files :editable="isCourseEquivalentsManager" :files="files" @fileAdded="addFile"
            @fileRemoved="removeFile"></course-equivalent-files>
        </widget>
      </b-col>
    </b-row>
    <b-button v-if="isCourseEquivalentsManager" v-b-modal.edit-modal variant="primary"
      class="ml-2 pull-right">Edit</b-button>
  </b-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import courseEquivalentsApi from "../../api/courseEquivalents";
import termsApi from "../../api/terms";
import CourseEquivalentForm from "../../components/workloads/course-equivalent-form";
import CourseEquivalentFiles from "../../components/workloads/course-equivalent-files";
import Widget from "../../components/widget";
import ToastrSettings from "../../settings/toastr-settings";
import toastr from "toastr";
import roleChecks from "../../misc/role-checks";
import { required } from "vuelidate/lib/validators";

export default {
  mixins: [roleChecks],
  name: "CourseEquivalentDetails",
  data() {
    return {
      openEditModal: false,
      attemptEditSubmit: false,
      item: null,
      form: {
        id: null,
        statusId: null
      },
      terms: [],
      statuses: [],
      files: []
    };
  },

  props: {
    id: {
      required: true
    }
  },

  components: {
    widget: Widget,
    CourseEquivalentForm,
    CourseEquivalentFiles
  },

  validations: {
    form: {
      statusId: { required },
      notes: {}
    }
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },

  methods: {
    ...mapActions("workloads", ["addWorkloadFiles"]),
    load: function () {
      courseEquivalentsApi.getById(this.id).then(response => {
        this.item = response.data;
      });

      courseEquivalentsApi.getFiles(this.id).then(response => {
        this.files = response.data;
      });
    },
    save(formData) {
      var courseEquivalent = formData.form;
      if (courseEquivalent) {
        this.attemptEditSubmit = false;
        courseEquivalentsApi
          .put(courseEquivalent.id, courseEquivalent)
          .then(() => {
            toastr.options = ToastrSettings;
            toastr.success("The request has been saved.", "Success");
            this.load();
            this.openEditModal = false;
          });
      }
    },

    addFile(files) {
      var that = this;

      courseEquivalentsApi.postFiles(this.id, files).then(() => {
        this.load();

        _.forEach(files, function (file) {
          that.files.push(file);
          that.files.unshift({
            fileName: file.name,
            createdBy: that.user.userId,
            createdDate: new Date(),
            _rowVariant: "success"
          });
        });
      });
    },

    removeFile(file) {
      this.$emit("fileRemoved", file);
    }
  },

  created() {
    this.load();
    courseEquivalentsApi.getStatuses().then(response => {
      this.statuses = response.data;
    });
    termsApi.getCurrentAndFutureTerms().then(response => {
      this.terms = response.data;
    });
  }
};
</script>

<style scoped>
.main-container {
  max-width: 100%;
  margin-top: 10px;
}
</style>
